import React from 'react';
import { motion } from 'framer-motion';
export function Timeline() {
  const phases = [{
    period: 'Week 1-2',
    title: 'De Overgang',
    description: 'Geleidelijk overschakelen. Mogelijk tijdelijke ontgiftingsverschijnselen. Het lichaam went aan het nieuwe voer.'
  }, {
    period: 'Week 3-4',
    title: 'Eerste Resultaten',
    description: 'Ontlasting verbetert (kleiner, donkerder, minder vaak). Vacht begint te glanzen. Hond wordt rustiger.'
  }, {
    period: 'Week 6-8',
    title: 'Zichtbare Transformatie',
    description: 'Darmflora hersteld. Jeuk en huidproblemen verminderen. Energie neemt toe. Gedrag stabiliseert.'
  }, {
    period: 'Week 12+',
    title: 'Volledig Herstel',
    description: 'Je hond straalt gezondheid uit. Intoleranties kunnen verdwenen zijn. Dit is het nieuwe normaal.'
  }];
  return <section className="py-20 bg-[#F5F5F5]" data-id="element-220">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-222">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-223">
            Wat Je Kunt Verwachten
          </h2>
          <p className="text-gray-600" data-id="element-224">Een gezonde hond in 4 stappen</p>
        </motion.div>

        <div className="max-w-3xl mx-auto relative" data-id="element-225">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-gray-300 transform md:-translate-x-1/2" data-id="element-226"></div>

          <div className="space-y-12" data-id="element-227">
            {phases.map((phase, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className={`relative flex flex-col md:flex-row gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-228">
                {/* Timeline Dot */}
                <div className="absolute left-4 md:left-1/2 w-4 h-4 bg-[#4DBFB8] rounded-full border-4 border-white shadow-md transform -translate-x-1/2 mt-1.5 z-10" data-id="element-229"></div>

                {/* Content */}
                <div className="ml-12 md:ml-0 md:w-1/2 p-6 bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow" data-id="element-230">
                  <span className="inline-block px-3 py-1 bg-[#4DBFB8]/10 text-[#4DBFB8] text-xs font-bold rounded-full mb-2" data-id="element-231">
                    {phase.period}
                  </span>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-232">
                    {phase.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-233">
                    {phase.description}
                  </p>
                </div>

                {/* Empty space for the other side */}
                <div className="hidden md:block md:w-1/2" data-id="element-234"></div>
              </motion.div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-235">
            <p className="inline-block bg-[#E85D5D]/10 text-[#E85D5D] px-6 py-3 rounded-lg font-bold" data-id="element-236">
              Belangrijk: Geef het minimaal 8 weken. Echte verandering kost
              tijd.
            </p>
          </div>
        </div>
      </div>
    </section>;
}